module.exports = __webpack_public_path__ + "img/ie-1.724708cb.jpg";